import React from "react";
import RMQAPIUploadsHistoryViewTable from "./rmqAPIUploadsHistoryView";
import "../util/tables.css";
import { useDataView } from "../../contexts/data.view.context";
import { Tooltip } from "@mui/material";
import { useFetchOnMount } from "../../hooks/useFetchOnMount";

const RmqApiUploadHistoryView = () => {
  const columns = [
    {
      id: "projectId",
      accessorKey: "projectId",
      header: "Project ID",
      size: 75,
    },
    {
      id: "transferName",
      accessorKey: "transferName",
      header: "Transfer Name",
      size: 75,
    },
    {
      id: "createdDt",
      accessorKey: "createdDt",
      header: "Date",
      size: 100,
    },
    {
      id: "status",
      accessorKey: "status",
      header: "Status",

      size: 50,

      Cell: ({ row }) => {
        let value = row.original.status;
        let hoverDesc = row.original.returnDesc;
        value = "" + value;

        if (value === "200") {
          return <p style={{ color: "green" }}>{value}</p>;
        }

        return (
          <Tooltip title={hoverDesc || ""} arrow>
            <p style={{ color: "red", margin: 0, cursor: "help" }}>{value}</p>
          </Tooltip>
        );
      },
    },
    {
      id: "fileName",
      accessorKey: "fileName",
      header: "File Name",
      size: 200,
    },
    {
      id: "IngestRunId",
      accessorKey: "IngestRunId",
      header: "IngestRunId",
      size: 100,
    },
    {
      id: "QueuedFilename",
      accessorKey: "QueuedFilename",
      header: "QueuedFilename",
      size: 200,
    },
  ];
  const { fetchfileTransferHistory, fileTransferHistory } = useDataView();

  useFetchOnMount(fileTransferHistory, fetchfileTransferHistory);

  let projectsList = null;
  let mainCmdGroupList = null;
  let mainTransferNameList = null;

  if (fileTransferHistory.length > 0) {
    let list = fileTransferHistory.map((fileHistory) => {
      if (fileHistory.projectId === null) {
        fileHistory.projectId = "TESTS_PROJECT";
      }
      return fileHistory.projectId;
    });

    let uniq = [...new Set(list)];

    projectsList = uniq.map((projectId) => {
      return { value: projectId, label: projectId };
    });

    list = fileTransferHistory.map((fileHistory) => {
      return fileHistory.cmdGroup;
    });

    uniq = [...new Set(list)];

    mainCmdGroupList = uniq.map((cmdGrp) => {
      return { value: cmdGrp, label: cmdGrp };
    });

    list = fileTransferHistory.map((fileHistory) => {
      return fileHistory.transferName;
    });

    uniq = [...new Set(list)];

    mainTransferNameList = uniq
      .filter((transferName) => transferName.toUpperCase() !== "ARCHIVE") // Case-insensitive skip
      .map((transferName) => {
        return { value: transferName, label: transferName };
      });
  }

  // if new file transfer is added to work via api, extend the list here
  // once we configure all RMQ bound transfers to API uploads, we can filter by destination = RMQ
  const allowedProjectIds = ["ACAC216676"];

  return (
    <>
      <div className="relative">

        {fileTransferHistory.length > 0 && (
          <RMQAPIUploadsHistoryViewTable
            columns={columns}
            data={fileTransferHistory
              .filter(
                (fileHistory) =>
                  allowedProjectIds.includes(fileHistory.projectId) &&
                  fileHistory.cmdGroup !== "ARCHIVE"
              )
              .map((fileHistory) => {
                let FilenameProvider = null;
                let IngestRunId = null;
                let QueuedFilename = null;
                let returnDesc = null;

                // fileHistory.details is a JSON string, so parse it first
                let detailsObj = null;
                try {
                  detailsObj = JSON.parse(fileHistory.details);
                } catch (e) {
                  console.warn("details is not valid JSON", e);
                }

                // Only continue if parsing succeeded
                if (detailsObj) {
                  const returnMessageStr = detailsObj?.result?.returnMessage;
                  returnDesc = detailsObj?.result?.returnDesc;

                  if (returnMessageStr) {
                    try {
                      // Parse returnMessage (it’s a JSON string as well)
                      let returnMessages = JSON.parse(returnMessageStr);

                      // Sometimes returnMessage is double-encoded
                      if (typeof returnMessages === "string") {
                        returnMessages = JSON.parse(returnMessages);
                      }

                      if (
                        Array.isArray(returnMessages) &&
                        returnMessages.length > 0
                      ) {
                        FilenameProvider =
                          returnMessages[0]?.FilenameProvider ?? null;
                        IngestRunId =
                          returnMessages[0]?.Queued?.[0]?.IngestRunId ?? null;
                        QueuedFilename =
                          returnMessages[0]?.Queued?.[0]?.QueuedFilename ??
                          null;
                      }
                    } catch (e) {
                      console.warn("returnMessage is not valid JSON", e);
                    }
                  }
                }

                return {
                  transferId: fileHistory.transferId,
                  transferSeq: fileHistory.transferSeq,
                  status: fileHistory.status,
                  fileName: FilenameProvider,
                  fromPath: fileHistory.fromPath,
                  toPath: fileHistory.toPath,
                  transferName: fileHistory.transferName,
                  cmdGroup: fileHistory.cmdGroup,
                  projectId: fileHistory.projectId,
                  source: fileHistory.source,
                  destination: fileHistory.destination,
                  createdDt: fileHistory.createdDt,
                  createdBy: fileHistory.createdBy,
                  IngestRunId: IngestRunId,
                  QueuedFilename: QueuedFilename,
                  returnDesc: returnDesc,
                };
              })}
            projectsList={projectsList}
            mainCmdGroupList={mainCmdGroupList}
            mainTransferNameList={mainTransferNameList}
          />
        )}
      </div>
    </>
  );
};

export default RmqApiUploadHistoryView;
